import { SxProps, Theme } from '@mui/material/styles';

export const subtitleSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '10px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#4A4A4A',
  width: '158px',
};

export const titleSx: SxProps<Theme> = {
  fontFamily: 'BDO Grotesk, sans-serif',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#CCD4FF',
};

export const amountInputSx: SxProps<Theme> = {
  width: '446px',
  mb: 2,
  '& .MuiOutlinedInput-root': {
    height: '61px',
    borderRadius: '11.71px',
    backgroundColor: '#1E1F25',
    '& fieldset': {
      border: '1px solid #FFFFFF1A',
    },
    '& input': {
      padding: '24px',
    },
  },
};